import { DataSource } from "@angular/cdk/table";
import { BehaviorSubject, Observable } from "rxjs";
import { MatPaginator, MatSort, MatSpinner } from "@angular/material";
import { IDataSource } from "../../../datasource/data-source";
import { SearchDataSourceOptions } from "../../../datasource/search-data-source-options";
import { DataSourceQuery } from "../../../datasource/data-source-query";

export class SearchMatTableDataSource extends DataSource<any> {

    protected subject$ = new BehaviorSubject<any[]>([]) ;
    private orderby : { active:string, direction:string }  ;
    private loading$ = new BehaviorSubject<boolean>(false) ;
    public spinner: MatSpinner
    protected lastQuery: DataSourceQuery ;

    constructor(
        private datasource : IDataSource)
    {
        super();
        //this.refresh() ;
    }

    protected _paginator: MatPaginator ;
    set paginator(paginator : MatPaginator | null) {
       this._paginator = paginator ;
       this._paginator.page.subscribe(
        x => {
          // {"previousPageIndex":0,"pageIndex":1,"pageSize":10,"length":100}
          this.update(this.lastQuery) ;
        }
      )
    }

    protected _sort: MatSort ;
    set sort(sort : MatSort | null) {
       this._sort = sort ;
       this._sort.sortChange.subscribe(
        ob => {
          // {active: "detail", direction: ""}
          this.orderby = ob ;
          this.update(this.lastQuery) ;
        }
      )
    }

    protected update(query:DataSourceQuery) {
        let page = (this._paginator) ? this._paginator.pageIndex : 0 ;
        let pageSize = (this._paginator) ? this._paginator.pageSize : 10 ;
        let options: SearchDataSourceOptions = this.datasource.defaultOptions() ;

        // Setup orderby option if it's available
        let orderby = this.orderby ;
        if(orderby && orderby.direction && orderby.active) {
            if(orderby.direction.toLowerCase() == "desc")
                options.orderBy = `-${orderby.active}` ;
            else
                options.orderBy = `+${orderby.active}` ;
        }
        options.query = query ;

        this.loading$.next(true) ;
        this.datasource.read(page, pageSize, options).subscribe(
            results => {
                this._paginator.length = results.total ;
                this.subject$.next(results.data) ;
            },
            error => { this.loading$.next(false) ; },
            () => { this.loading$.next(false) ; }
        ) ;

        this.lastQuery = query ;
    }

    /**
     * Subscribe to this observable if you want to be informed when the datasource is loading.
     */
    public get loadingEvents() : Observable<boolean> {
        return (this.loading$) ;
    }

    public search(query:DataSourceQuery) {
        this._paginator.pageIndex = 0 ;
        this.update(query) ;
    }

    public refresh() {
        this.update(this.lastQuery) ;
    }

    public reset() {
        this.clear() ;
    }

    public clear() {
        this._paginator.pageIndex = 0 ;
        this._paginator.length = 0 ;
        this.subject$.next([]) ;
    }

    connect(): BehaviorSubject<any[][]> {
      return (this.subject$) ;
    }

    disconnect() {}
  }

